/**
 * @generated SignedSource<<b06622d8ac8c1c8119d88a3a8757eae5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type shippingCostHelpers_item$data = {
  readonly shipmentQuotes: ReadonlyArray<{
    readonly isComplimentary: boolean | null;
    readonly serviceMethod: {
      readonly region: {
        readonly regionName: string | null;
      } | null;
    } | null;
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null> | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "shippingCostHelpers_item";
};
export type shippingCostHelpers_item$key = {
  readonly " $data"?: shippingCostHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shippingCostHelpers_item"
};

(node as any).hash = "bdab7104c6c6efef45f633a60a3578e7";

export default node;
